const state = {
  address: null,
};

const mutations = {
  SET_ADDRESS(state, address) {
    state.address = address;
  },
};

const actions = {
  setAddress({ commit }, address) {
    commit('SET_ADDRESS', address);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
